import { React } from 'react';

import { Oval } from 'react-loader-spinner';

const Spinner = ({loaderType="section", height="50", width="50"}) => {

    return (
        <Oval
            visible={true}
            height={height}
            width={width}
            color="#0064FF"
            strokeWidth="4"
            strokeWidthSecondary="4"
            secondaryColor={loaderType === "section" ? "#18e7f8b2" : "#FFFFFF"}
            ariaLabel="oval-loading"
            wrapperStyle={{}}
            wrapperClass=""
        />
    )
}

export default Spinner;